import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { Box } from "@/components/ui/box";
import { ScrollView } from "react-native-gesture-handler";
import i18n from "i18n-js";
import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import Footer from "@/components/basic/Footer";
import ContactElement from "@/components/basic/ContactElement";
import BasicElement from "@/components/basic/BasicElement";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { switchScreen } from '@/hooks/navigate';
import useRefreshEffect from '@/hooks/refreshed';

export default function Contacts({ navigation, route }) {
    const insets = useSafeAreaInsets()

    const { channel, isFinal, isPlanner, task } = route.params
    const user = useSelector((state) => state.user)
    const contacts = useSelector((state) => state.contacts)
    const [actContacts, setActContacts] = useState(contacts.active.filter(contact => (!channel || channel.contacts.includes(contact.id)) && (!isPlanner || contact.planningForAllowed)))

    const actions = [
        { icon: 'keyboard-arrow-left', text: 'footer.back', component: 'BACK' },
        { icon: 'home', text: 'footer.home', component: 'Home' },
        isPlanner
            ? { icon: 'playlist-add', text: 'plannerRequest.request', component: 'PlannerRequests', marker: contacts.active.filter(c => c.planningRequestFrom !== null).length > 0}
            :  { icon: '' }
    ]

    useEffect(() => {
        navigation.setOptions(channel ? { title: channel.name, info: i18n.t('channel.info') } : { title: i18n.t(isPlanner ? 'contact.planner' : 'contact.contacts') })
    }, [])

    useRefreshEffect(() => {
        setActContacts(contacts.active.filter(contact => (!channel || channel.contacts.includes(contact.id)) && (!isPlanner || contact.planningForAllowed)))
        navigation.setOptions(channel ? { title: channel.name, info: i18n.t('channel.info') } : { title: i18n.t(isPlanner ? 'contact.planner' : 'contact.contacts') })
    }, [contacts, isPlanner])

    return (
        <View className="flex-1 bg-secondary-50">
            <ScrollView scrollIndicatorInsets={{ right: 1 }} contentContainerStyle={{ paddingBottom: 70 + insets.bottom }} className="flex-1 bg-secondary-50">
                <VStack>
                    {isPlanner && <>
                        <Text className="px-3 py-3 text-2xl text-secondary-900">{i18n.t('contact.planForMe')}</Text>
                        <ContactElement
                            uri={user.avatar}
                            title={user.mail} text={user.preferredName}
                            onPress={() => task ? switchScreen(navigation, 'ScheduleWorkflow', { task: task, plans: [null], toTask: true }) : switchScreen(navigation, 'Planner', { isEdit: true })} />
                    </>}
                    {(!isPlanner || actContacts.length > 0) && <Text className="px-3 py-3 text-2xl text-secondary-900">{i18n.t(channel ? 'channel.contacts' : 'contactManagement.contacts', { num: actContacts.length })}</Text>}
                    {isFinal ?
                        actContacts.map((contact, index) =>
                            <Box key={'A' + index} className="px-3">
                                <BasicElement
                                    media={contact?.contactImage?.id || contact.toUser.id}
                                    sync={'/contact/media/' + (contact?.contactImage?.id || contact.toUser.id)}
                                    title={contact.contactAlias || contact.toUser.mail}
                                    text={contact.toUser.preferredName}
                                />
                            </Box>
                        )
                        : actContacts.map((contact, index) =>
                            <ContactElement
                                key={'A' + index}
                                uri={contact?.contactImage?.id || contact.toUser.id}
                                title={contact.contactAlias || contact.toUser.mail} text={contact.toUser.preferredName}
                                onPress={() => isPlanner ? (task ? switchScreen(navigation, 'ScheduleWorkflow', { task: task, plans: [null], contact: contact, toTask: true }) : switchScreen(navigation, 'Planner', { contact: contact, isEdit: true })) : switchScreen(navigation, 'Contact', { contact: contact, isEdit: false })} />)
                    }
                </VStack>
            </ScrollView>
            <Footer navigation={navigation} actions={actions}/>
        </View>
    );
}
